export const getFileExtension = (filename: string) =>
  filename.split(".").pop()?.toLowerCase()

export const isImage = (extension: string) =>
  extension.match(/(jpg|jpeg|png|gif|svg)$/i) ?? false

export const bytesToMB = (size: number) => size / 1024 / 1024
